import React from 'react';
import { Edit, SimpleForm, BooleanInput, Toolbar, SaveButton } from 'react-admin';
import DisableW2MarkupsFeatureGateContext from '../DisableW2MarkupsFeatureGateContext';

const AssignmentsEdit = () => (
  <Edit mutationMode="pessimistic" redirect="show">
    <DisableW2MarkupsFeatureGateContext />
    <SimpleForm
      toolbar={
        <Toolbar>
          <SaveButton />
        </Toolbar>
      }
    >
      <BooleanInput label="SSN Card Image" source="needs_item_url" />
    </SimpleForm>
  </Edit>
);

export default AssignmentsEdit;
